// The empty «Проекты» of a new account (plan N1, R-E5): instead of a blank table, the first project in one step — a name, dates and a
// city; the project, its first event and the event's forms are made at once, and the event opens on «Запуск».
import { useState } from 'react';
import { Button, DateInput, Field, Input, navigate, openOnTab, recordHref, useScope } from '@confdeck/core-web';
import { command } from './command.ts';
import s from './conferences.module.css';

export function FirstConference() {
  const [name, setName] = useState('');
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [city, setCity] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [, setScope] = useScope();
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    const r = await command<{ eventId: string }>('conference.start', { name, ...(start ? { start } : {}), ...(end ? { end } : {}), ...(city.trim() ? { city: city.trim() } : {}) });
    setBusy(false);
    if (!r.ok) { setError(r.message); return; }
    setScope(r.result.eventId);
    openOnTab(r.result.eventId, 'launch');
    navigate(recordHref(r.result.eventId));
  };
  return (
    <form className={s.first} onSubmit={(e) => void submit(e)}>
      <h2 className={s.firstTitle}>Как называется проект?</h2>
      <p className={s.firstLead}>Проект объединяет ваши события: встречи, эфиры, марафоны. Создадим проект и его первое событие с черновиками форм. Остальное подскажет список «Запуск» события.</p>
      <Field label="Название проекта"><Input autoFocus value={name} placeholder="Например, DevConf или Марафон продаж" aria-label="Название проекта" onChange={(e) => setName(e.target.value)} required /></Field>
      <p className={s.firstLead}>Первое событие проекта — даты можно указать позже.</p>
      <div className={s.firstRow}>
        <Field label="Начало"><DateInput value={start} aria-label="Дата начала" onChange={setStart} /></Field>
        <Field label="Окончание"><DateInput value={end} aria-label="Дата окончания" onChange={setEnd} /></Field>
      </div>
      <Field label="Город" hint="Можно оставить пустым для онлайн-события"><Input value={city} aria-label="Город" onChange={(e) => setCity(e.target.value)} /></Field>
      {error && <p className={s.firstError} role="alert">{error}</p>}
      <Button type="submit" variant="primary" size="lg" disabled={busy || !name.trim()}>Создать проект</Button>
    </form>
  );
}
